import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import TopBar from "@/components/TopBar";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const nav = useNavigate();

  useEffect(() => {
    if (!sid) return;
    let n = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/checkout/status/${sid}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch {
        // Silent retry; final state handled by timeout counter below.
      }
      n++;
      if (n < 10) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sid]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopBar />
      <div className="max-w-md mx-auto px-6 py-20 text-center">
        {status === "polling" && <div className="font-mono-data text-sm text-[#8a8a8e]">VERIFYING PAYMENT…</div>}
        {status === "paid" && (
          <>
            <div className="font-heading text-4xl text-[#00e676]" data-testid="payment-paid">PAID</div>
            <p className="mt-4 text-sm text-[#8a8a8e]">Pro unlocked for 30 days.</p>
            <button onClick={() => nav("/")} className="mt-6 px-6 py-2 bg-white text-black text-xs font-mono-data uppercase tracking-widest">Go to Dashboard</button>
          </>
        )}
        {status === "expired" && <div className="font-mono-data text-[#ff3b30]">SESSION EXPIRED</div>}
        {status === "timeout" && <div className="font-mono-data text-[#ffcc00]">STATUS UNCLEAR — CHECK BACK SHORTLY</div>}
      </div>
    </div>
  );
}
